/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { QuestConfig } from './QuestConfig';
import {
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
    QuestConfigToJSONTyped,
} from './QuestConfig';

/**
 * 
 * @export
 * @interface GetQuestConfigsResponse
 */
export interface GetQuestConfigsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetQuestConfigsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof GetQuestConfigsResponse
     */
    questConfigs: Array<QuestConfig>;
}

/**
 * Check if a given object implements the GetQuestConfigsResponse interface.
 */
export function instanceOfGetQuestConfigsResponse(value: object): value is GetQuestConfigsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('questConfigs' in value) || value['questConfigs'] === undefined) return false;
    return true;
}

export function GetQuestConfigsResponseFromJSON(json: any): GetQuestConfigsResponse {
    return GetQuestConfigsResponseFromJSONTyped(json, false);
}

export function GetQuestConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestConfigsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'questConfigs': ((json['questConfigs'] as Array<any>).map(QuestConfigFromJSON)),
    };
}

export function GetQuestConfigsResponseToJSON(json: any): GetQuestConfigsResponse {
    return GetQuestConfigsResponseToJSONTyped(json, false);
}

export function GetQuestConfigsResponseToJSONTyped(value?: GetQuestConfigsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'questConfigs': ((value['questConfigs'] as Array<any>).map(QuestConfigToJSON)),
    };
}

